import {
    ErrorResponse,
    SummarizePaymentsByDriverMonthRequest,
    SummarizePaymentsByOfficeRequest,
} from "../../api";
import { paymentsSlice } from "../../features/UsageBased_Summary/store";
import { commonSlice, store } from "../../store";
import { viewMonth2numeric } from "../../utils/time";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";

export const select_summary_row = async (
    selectedMonth: string,
    office_id: number
): Promise<void> => {
    await store.dispatch(
        paymentsSlice.actions.update_selected_month(selectedMonth)
    );
    await store.dispatch(commonSlice.actions.updateSelectedOffice(office_id));
    console.debug("Select month...", store.getState().payments.selectedMonth);
};

export async function selectPaymentsByDriver(): Promise<void> {
    store.dispatch(commonSlice.actions.startLoading());
    store.dispatch(paymentsSlice.actions.update_payments_by_driver(null));
    const state = store.getState();

    try {
        const req: SummarizePaymentsByDriverMonthRequest = {
            officeId: state.common.selectedOfficeId!,
            month: viewMonth2numeric(state.payments.selectedMonth),
        };
        const res = await api
            .getPaymentSummaryAPI()
            .summarizePaymentsByDriverMonth(req);

        sendLog(
            ResourceType.PAYMENTS_BY_DRIVER,
            StatusType.GET_RESOURCE,
            ActionType.PAYMENT_BY_DRIVER
        );

        console.debug("Payments by driver for month.........", res);
        await store.dispatch(
            paymentsSlice.actions.update_payments_by_driver(res)
        );
    } catch (err) {
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }

        const res = (await (err as Response).json()) as ErrorResponse;

        if (err["status"] == 401) {
            console.log("Console is reloading...", res);
            return;
        }
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}

export async function selectPaymentsSummary(): Promise<void> {
    store.dispatch(commonSlice.actions.startLoading());
    store.dispatch(paymentsSlice.actions.update_payments_summary(null));
    const state = store.getState();

    const officeId =
        state.common.selectedOfficeId == -1
            ? undefined
            : state.common.selectedOfficeId;

    let officeIds = state.common.officeIds;

    if (officeId) {
        officeIds = [officeId];
    }

    console.debug(
        "Getting payments summary...",
        state.payments.paymentsSummaryInput.start_month,
        viewMonth2numeric(state.payments.paymentsSummaryInput.start_month)
    );

    try {
        const req: SummarizePaymentsByOfficeRequest = {
            officeId,
            startMonth: viewMonth2numeric(
                state.payments.paymentsSummaryInput.start_month
            ),
            endMonth: viewMonth2numeric(
                state.payments.paymentsSummaryInput.end_month
            ),
            officeIds,
        };
        console.log("Payments summary:: request...", req);
        const res = await api
            .getPaymentSummaryAPI()
            .summarizePaymentsByOffice(req);

        sendLog(
            ResourceType.PAYMENTS_SUMMARY,
            StatusType.GET_RESOURCE,
            ActionType.PAYMENT_SUMMARY
        );

        console.debug("Payments summary:: by office:", res);
        await store.dispatch(
            paymentsSlice.actions.update_payments_summary(res)
        );
    } catch (err) {
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }

        const res = (await (err as Response).json()) as ErrorResponse;

        if (err["status"] == 401) {
            console.log("Console is reloading...", res);
            return;
        }
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
